import React from 'react';
import { motion } from 'framer-motion';

function Testimonials({ testimonials }) {
  if (!testimonials?.length) return null;

  return (
    <section
      id="testimonials"
      className="section-space bg-paper"
      aria-labelledby="testimonials-heading"
      data-aos="fade-up"
    >
      <div className="section-wrap">
        <div className="mb-14 flex flex-col gap-6 md:mb-20 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="meta-label">04 / Trusted By</p>
            <h2
              id="testimonials-heading"
              className="mt-4 font-display text-4xl font-bold uppercase leading-[0.86] tracking-[-0.03em] md:text-6xl"
            >
              Clients &
              <br />
              Collaborators
            </h2>
          </div>
          <p className="max-w-xs text-sm uppercase tracking-[0.2em] text-ink/50 md:text-right">
            Real feedback from freelance projects and enterprise teams.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {testimonials.map((item, i) => (
            <motion.figure
              key={item.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="ui-card-hover relative flex h-full flex-col justify-between rounded-[1.4rem] border border-ink/10 bg-snow/70 p-7 backdrop-blur-sm"
            >
              <span
                aria-hidden="true"
                className="absolute -top-3 left-6 font-display text-6xl leading-none text-accent/60"
              >
                “
              </span>
              <blockquote className="copy-refined text-sm text-ink/82 md:text-base">{item.quote}</blockquote>
              <figcaption className="mt-6 border-t border-ink/10 pt-4">
                <p className="text-sm font-semibold uppercase tracking-[0.16em] text-ink">{item.name}</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.22em] text-ink/55">{item.role}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
